import './PwaInstallMenuItem.scss';

import {DownloadOutlined} from '@ant-design/icons';
import {message, Modal} from 'antd';
import React, {useState, useSyncExternalStore} from 'react';

import * as localizationKeys from '../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import pwaInstallService from '../../services/pwa/pwaInstallService';
import AntButton from '../AntButton/AntButton';
import MobileSheet from '../MobileUi/MobileSheet';

const PwaInstallMenuItem = ({onMobileMenuClose, mobile = false}) => {
    const isMobile = useIsMobileViewport();
    const strings = getLocalizedStrings();
    const flow = useSyncExternalStore(pwaInstallService.subscribe, pwaInstallService.getSnapshot);
    const [instructionsOpen, setInstructionsOpen] = useState(false);
    const closeInstructions = () => setInstructionsOpen(false);
    const installationSteps = [
        localizationKeys.PWA_INSTALL_STEP_SAFARI,
        localizationKeys.PWA_INSTALL_STEP_SHARE,
        localizationKeys.PWA_INSTALL_STEP_HOME_SCREEN,
        localizationKeys.PWA_INSTALL_STEP_ADD,
    ];

    const onInstallClick = async () => {
        onMobileMenuClose();
        if (flow === 'ios') {
            setInstructionsOpen(true);
            return;
        }
        try {
            await pwaInstallService.install();
        } catch (_) {
            message.error(
                'Не вдалося відкрити встановлення. Спробуйте знову, коли браузер запропонує встановити застосунок.'
            );
        }
    };

    return (
        <>
            {flow && (
                <button
                    type='button'
                    className={
                        mobile
                            ? 'mobile-navigation-install'
                            : 'flex h-[66px] w-full flex-col items-center justify-center text-santa hover:cursor-pointer'
                    }
                    onClick={onInstallClick}
                >
                    <DownloadOutlined className={mobile ? 'text-18' : 'mb-[3px] text-24'} aria-hidden />
                    <span
                        className={
                            mobile ? undefined : 'max-w-[101px] px-2 text-center text-11 font-semibold leading-12'
                        }
                    >
                        Встановити застосунок
                    </span>
                </button>
            )}
            {isMobile ? (
                <MobileSheet
                    open={!!flow && instructionsOpen}
                    onClose={closeInstructions}
                    title={strings[localizationKeys.PWA_INSTALL_TITLE]}
                    closeLabel={strings[localizationKeys.PWA_INSTALL_CLOSE]}
                    className='pwa-install-sheet'
                >
                    <div className='pwa-install-instructions'>
                        <p>{strings[localizationKeys.PWA_INSTALL_INTRO]}</p>
                        <ol>
                            {installationSteps.map((key) => (
                                <li key={key}>{strings[key]}</li>
                            ))}
                        </ol>
                        <p className='pwa-install-note'>{strings[localizationKeys.PWA_INSTALL_NOTE]}</p>
                    </div>
                    <div className='pwa-install-actions'>
                        <AntButton primary className='h-12 w-full' onClick={closeInstructions}>
                            {strings[localizationKeys.PWA_INSTALL_ACKNOWLEDGE]}
                        </AntButton>
                    </div>
                </MobileSheet>
            ) : (
                <Modal
                    title='Встановити Energy Portal'
                    open={!!flow && instructionsOpen}
                    onCancel={() => setInstructionsOpen(false)}
                    width={420}
                    footer={
                        <AntButton primary className='ml-auto w-auto px-4' onClick={() => setInstructionsOpen(false)}>
                            Зрозуміло
                        </AntButton>
                    }
                >
                    <p>Щоб установити Energy Portal на iPhone або iPad:</p>
                    <ol className='my-3 list-decimal space-y-2 pl-5'>
                        <li>Відкрийте цю сторінку у Safari.</li>
                        <li>Натисніть «Поділитися».</li>
                        <li>Оберіть «На початковий екран».</li>
                        <li>Натисніть «Додати».</li>
                    </ol>
                    <p>Після встановлення відкрийте Energy Portal з іконки на початковому екрані.</p>
                </Modal>
            )}
        </>
    );
};

export default PwaInstallMenuItem;
